import { Box, Typography, Link, Divider } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export default function Footer() {
  return (
    <>
      <Divider
        sx={{
          width: "100%",
          height: "1px",
          backgroundColor: "divider",
        }}
      />

      <Box
        sx={{
          backgroundColor: "background.paper",
          px: { xs: 2, md: 4 },
          py: 5,
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          gap: 4,
          flexWrap: "wrap",
        }}
      >
        <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
          <img src="/logo.png" alt="EDEB-Estrichbau" style={{ height: 120, filter: "drop-shadow(0px 0px 12px rgba(255, 255, 255, 0.8)) drop-shadow(0px 0px 4px rgba(255, 255, 255, 1))" }} />
        </Box>

        <Box sx={{ flex: 1, textAlign: "center" }}>
          <Typography variant="h6" color="primary">Kontakt</Typography>
          <Typography sx={{ mt: 1, color: "text.secondary" }}>
            Für alle Ihre Fragen stehen wir Ihnen jederzeit gerne zur Verfügung.
          </Typography>
          <Typography sx={{ mt: 1, color: "text.primary" }}>Tel: 0162 4196199</Typography>
          <Typography color="text.primary">Mail: edeb-estrichbau@web.de</Typography>
        </Box>

        <Box sx={{ flex: 1, textAlign: "center" }}>
          <Typography variant="h6" color="primary">Adresse</Typography>
          <Typography sx={{ mt: 1, color: "text.primary" }}>EDEB-Estrichbau</Typography>
          <Typography color="text.primary">65760 Eschborn</Typography>
        </Box>

        <Box sx={{ flex: 1, textAlign: "center" }}>
          <Typography variant="h6" color="primary">Rechtliches</Typography>
          <Typography sx={{ mt: 1 }}>
            <Link
              component={RouterLink}
              to="/impressum"
              underline="hover"
              color="text.primary"
            >
              Impressum
            </Link>
          </Typography>
          <Typography>
            <Link
              component={RouterLink}
              to="/datenschutz"
              underline="hover"
              color="text.primary"
            >
              Datenschutz
            </Link>
          </Typography>
        </Box>
      </Box>
    </>
  );
}
